import { Check, Users } from "lucide-react";
import { CA } from "../config";
import MilestoneProgress, { MC_TARGETS, milestoneState, useMarketCap } from "./MilestoneProgress";
import Reveal from "./Reveal";

const MC = [
    { v: "$5K", l: "LAUNCH PUSH + FIRST MEMES" },
    { v: "$10K", l: "BALD IS AWAKE · 50+ HOLDERS + DAILY CONTENT" },
    { v: "$25K", l: "MEME CONTEST + CREATOR OUTREACH" },
    { v: "$50K", l: "BALD IS RUNNING · COMMUNITY GROWTH + STRONGER VOLUME" },
    { v: "$100K", l: "BALD IS FLYING · BIGGER MARKETING PUSH" },
    { v: "$250K", l: "BALD ARMY · X RAIDS + COLLABORATIONS" },
    { v: "$500K", l: "BALD TAKEOVER · HEAVY MARKETING PHASE" },
    { v: "$1M", l: "THE $BALD MILLION CLUB 👑", final: true },
    { v: "$43M", l: "END STATION 🚉 · AND EVEN THEN, WE KEEP BUILDING", end: true },
];

const HOLDERS = [
    { v: "100 HOLDERS", l: "COMMUNITY GIVEAWAY" },
    { v: "250 HOLDERS", l: "BIGGER MEME CONTEST" },
    { v: "500 HOLDERS", l: "$BALD COMMUNITY EVENT" },
    { v: "1,000 HOLDERS", l: "$BALD 1K CLUB" },
];

export default function Milestones() {
    const { data } = useMarketCap();
    const stats = data && !data.error ? data : null;
    const { reached, next } = milestoneState(stats?.marketCap);
    return (
        <section data-testid="milestones-section" className="relative overflow-hidden py-24 lg:py-32">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_0%,rgba(245,197,24,0.09),transparent)]" />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <Reveal className="flex flex-col items-center gap-4 text-center">
                    <span className="kicker !text-yellow-300">🚀 WE'RE STARTING BALD — BUT WE'RE NOT STOPPING HERE</span>
                    <h2 className="headline text-4xl sm:text-5xl lg:text-6xl">
                        <span className="text-gradient-gold">THE $BALD MILESTONES</span>
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <MilestoneProgress stats={stats} />
                </Reveal>

                <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
                    {MC.map((m, i) => {
                        const done = stats && i < reached;
                        const isNext = stats && MC_TARGETS[i] === next;
                        return (
                        <Reveal key={m.v} delay={i * 0.07} className={`h-full ${m.end ? "col-span-2 md:col-span-4" : ""}`}>
                            <div
                                data-testid={`milestone-card-${m.v.replace("$", "")}`}
                                data-state={done ? "reached" : isNext ? "next" : "locked"}
                                className={`glass relative flex h-full flex-col justify-between gap-4 overflow-hidden rounded-2xl p-5 transition-colors ${
                                    m.final ? "border-yellow-400/60 shadow-[0_0_40px_rgba(245,197,24,0.18)]" : ""
                                } ${m.end ? "items-center border-yellow-300/70 bg-[radial-gradient(ellipse_60%_100%_at_50%_100%,rgba(245,197,24,0.14),transparent)] text-center md:flex-row md:items-center md:justify-center md:gap-8 md:p-8" : ""} ${done ? "border-yellow-300/70 bg-yellow-400/[0.07]" : ""} ${isNext ? "border-yellow-300/40 animate-pulse-border" : ""}`}
                            >
                                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-yellow-400/20 via-yellow-300/80 to-yellow-400/20" style={{ width: `${((i + 1) / MC.length) * 100}%` }} />
                                <div className="flex flex-col gap-2">
                                    {done && (
                                        <span
                                            data-testid={`milestone-reached-${m.v.replace("$", "")}`}
                                            className="inline-flex w-fit items-center gap-1 rounded-full bg-yellow-300 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-widest text-black"
                                        >
                                            <Check className="h-3 w-3" /> REACHED
                                        </span>
                                    )}
                                    {isNext && (
                                        <span className="inline-flex w-fit rounded-full border border-yellow-300/50 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-widest text-yellow-300">
                                            NEXT UP
                                        </span>
                                    )}
                                    <span className={`headline text-gradient-gold ${m.end ? "text-4xl md:text-6xl" : "text-3xl md:text-4xl"}`}>
                                        {m.v} MC
                                    </span>
                                </div>
                                <span className={`font-mono uppercase leading-relaxed tracking-wider text-slate-400 ${m.end ? "text-xs md:max-w-xs md:text-left md:text-sm" : "text-[11px]"}`}>
                                    {m.l}
                                </span>
                            </div>
                        </Reveal>
                        );
                    })}
                </div>

                <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-4">
                    {HOLDERS.map((h, i) => (
                        <Reveal key={h.v} delay={i * 0.07} className="h-full">
                            <div
                                data-testid={`milestone-holders-${h.v.split(" ")[0]}`}
                                className="glass glass-hover flex h-full flex-col gap-2 rounded-2xl p-5"
                            >
                                <Users className="h-5 w-5 text-yellow-300" />
                                <span className="font-mono text-sm font-bold text-yellow-200">{h.v}</span>
                                <span className="font-mono text-[11px] uppercase tracking-wider text-slate-400">
                                    {h.l}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <p className="mt-8 text-center text-xs uppercase tracking-widest text-slate-500">
                        These are community milestones and goals, not financial promises.
                    </p>
                    <p className="mt-6 text-center font-mono text-sm text-slate-400">
                        🔥 No hair. No brakes. Just memes.
                        <br />
                        <span className="text-slate-500">CA: {CA}</span>
                    </p>
                    <p className="mt-4 text-center headline text-2xl text-white md:text-3xl">
                        GET BALD OR GET LEFT BEHIND.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
